import { render, staticRenderFns } from "./jobItem.vue?vue&type=template&id=39359676&scoped=true"
import script from "./jobItem.vue?vue&type=script&lang=js"
export * from "./jobItem.vue?vue&type=script&lang=js"
import style0 from "./jobItem.vue?vue&type=style&index=0&id=39359676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39359676",
  null
  
)

export default component.exports